import { render, staticRenderFns } from "./approvalControl.vue?vue&type=template&id=3d7ced8c&scoped=true&"
import script from "./approvalControl.vue?vue&type=script&lang=js&"
export * from "./approvalControl.vue?vue&type=script&lang=js&"
import style0 from "./approvalControl.vue?vue&type=style&index=0&id=3d7ced8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ced8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VItemGroup,VRow,VTooltip})
